import { apiInitRazorpay } from '../requests'
import {
  initRazorpayCheckout,
  apiInitRazorpayStart,
  apiInitRazorpaySuccess,
  apiInitRazorpayFail,
} from './actions'

export const operationProcessRazorpayCheckoutResponse = (response) => (dispatch) => {
  const { razorpayKey, orderId, submethod, rememberCustomer, customerID } = response?.pageAttributes
  dispatch(
    initRazorpayCheckout({
      keyId: razorpayKey,
      orderId,
      submethod,
      // TODO: Hybris will update to return rememberCustomer as a boolean (during w17), will then remove handling of type string. BTCOCPO-1100.
      rememberCustomer:
        typeof rememberCustomer === 'string' ? rememberCustomer === 'true' : rememberCustomer,
      customerId: customerID,
    }),
  )
}

// TODO: will be used for Hybris API call (k.solovei, 15.02.2023)
export const operationApiInitRazorpay = () => async (dispatch) => {
  dispatch(apiInitRazorpayStart())

  try {
    await apiInitRazorpay()
    dispatch(apiInitRazorpaySuccess())
  } catch (error) {
    dispatch(apiInitRazorpayFail())
  }
}
